import { CreateOptionsParams, ISpecializedCombo, useCombo } from "@hooks/useCombo";
import { MenuItem } from "@material-ui/core";
import { useContratoClienteService } from "@services/ContratoClienteService";
import { useThemeColor } from "@themes/Colors";
import { KeyOfEnum } from "@utils/TypeHelpers";
import React from "react";

export enum EnumContratoClienteStatus {
    None = "0",
    Ativo = 1,
    Inativo = 2,
    Cancelado = 3,
    Bloqueado = 4
}
export default interface IContratoClienteStatus {
    contratoClienteStatusId: EnumContratoClienteStatus,
    nome: string,
    ativo: string,
}

export type IComboContratoClienteStatus = ISpecializedCombo<IContratoClienteStatus>;

export function useContratoClienteStatusCombo (initialValue?: EnumContratoClienteStatus) : IComboContratoClienteStatus {
    const combo = useCombo<IContratoClienteStatus>({
        value: initialValue
    });

    const contratoClienteService = useContratoClienteService();

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((contratoClienteStatus, index) => {
            return <MenuItem key={index} value={contratoClienteStatus.contratoClienteStatusId}>{params?.prefix}{contratoClienteStatus.nome}{params?.sufix}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback(() => {
        combo.load(contratoClienteService.listarStatusAtivos)
    }, [combo, contratoClienteService.listarStatusAtivos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}

export function useContratoClienteStatusColor () {
    const themeColor = useThemeColor();

    const map : KeyOfEnum<EnumContratoClienteStatus, string> = React.useMemo(() => ({
        [EnumContratoClienteStatus.None]: "",
        [EnumContratoClienteStatus.Ativo]: themeColor.status.verde,
        [EnumContratoClienteStatus.Inativo]: themeColor.status.cinza,
        [EnumContratoClienteStatus.Cancelado]: themeColor.status.cinza,
        [EnumContratoClienteStatus.Bloqueado]: themeColor.status.vermelho,
    }), [themeColor.status.cinza, themeColor.status.verde, themeColor.status.vermelho]);

    return React.useMemo(() => map, [map]);
}